import { useGameStore } from '../../store/gameStore';
import { GameTable2D } from './GameTable2D';
import { PlayerSeat2D } from './PlayerSeat2D';

export function GameBoard() {
  const game = useGameStore((s) => s.game);
  const cameraMode = useGameStore((s) => s.cameraMode);
  const botActingPlayerIndex = useGameStore((s) => s.botActingPlayerIndex);
  const { players, activePlayerIndex, playerCount, dealerIndex, phase, settlementIndex } = game;

  const isOverview = cameraMode === 'overview';
  const highlightIndex = phase === 'settlement' ? settlementIndex : activePlayerIndex;

  if (playerCount === 0) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-white/50">
        게임을 시작하세요
      </div>
    );
  }

  return (
    <div
      className={`relative min-h-0 flex-1 ${
        isOverview ? 'touch-manipulation overflow-auto' : 'touch-none overflow-hidden'
      }`}
    >
      <div
        className={`board-container relative mx-auto h-full min-h-[280px] w-full max-w-2xl ${
          isOverview ? 'min-h-[420px] scale-[0.92]' : ''
        }`}
        style={isOverview ? { transformOrigin: 'center top' } : undefined}
      >
        <GameTable2D round={game.round} />
        {players.map((player) => (
          <PlayerSeat2D
            key={player.index}
            player={player}
            playerCount={playerCount}
            isActive={highlightIndex === player.index}
            isDealer={dealerIndex === player.index}
            isOverview={isOverview}
            isBotActing={botActingPlayerIndex === player.index}
          />
        ))}
      </div>
    </div>
  );
}
